import { render, staticRenderFns } from "./PedidoLog.vue?vue&type=template&id=63582ba8&scoped=true"
import script from "./PedidoLog.vue?vue&type=script&lang=js"
export * from "./PedidoLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63582ba8",
  null
  
)

export default component.exports